export function AppPreviewHomeIcon({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className={className}
    >
      <path
        d="M7.56669 14.1668H14.2334M10.0814 2.30345L4.42952 6.69939C4.05171 6.99324 3.86281 7.14017 3.72671 7.32417C3.60616 7.48716 3.51636 7.67077 3.46171 7.866C3.40002 8.08639 3.40002 8.3257 3.40002 8.80433V14.8334C3.40002 15.7669 3.40002 16.2336 3.58168 16.5901C3.74147 16.9037 3.99644 17.1587 4.31004 17.3185C4.66656 17.5001 5.13327 17.5001 6.06669 17.5001H15.7334C16.6668 17.5001 17.1335 17.5001 17.49 17.3185C17.8036 17.1587 18.0586 16.9037 18.2184 16.5901C18.4 16.2336 18.4 15.7669 18.4 14.8334V8.80433C18.4 8.3257 18.4 8.08639 18.3383 7.866C18.2837 7.67077 18.1939 7.48716 18.0733 7.32417C17.9372 7.14017 17.7483 6.99324 17.3705 6.69939L11.7186 2.30345C11.4258 2.07574 11.2795 1.96189 11.1178 1.91812C10.9752 1.87951 10.8249 1.87951 10.6822 1.91812C10.5206 1.96189 10.3742 2.07574 10.0814 2.30345Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </svg>
  );
}
